(function(SocialSharing, $, undefined) {

  // Private
  var injectPinterestScript = function() {
    var d = document;
    var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
    p.type = 'text/javascript';
    p.async = true;
    p.src = '//assets.pinterest.com/js/pinit.js';
    f.parentNode.insertBefore(p, f);
  };

  var bindUIActions = function() {
    $(document).on('click', '.social-sharing-icon', function(e) {
      e.preventDefault();
      switch($(this).data('network')) {
        case 'facebook':
          window.open('http://www.facebook.com/sharer/sharer.php?u=' + window.location.href, 'Facebook', "width=600, height=400, scrollbars=no");
          break;
        case 'twitter':
          window.open('http://www.twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href), 'Tweet', "width=600, height=400, scrollbars=no");
          break;
        case 'pinterest':
          var url = encodeURIComponent(window.location.href);
          var imgURL = encodeURIComponent($('.product-photo-container').find('img').first().attr('src'));
          var description = $('h1[itemprop=name]').text();
          window.open('http://pinterest.com/pin/create/button/?url=' + url + '&media=' + imgURL + '&description=' + description, 'Pinterest', "width=600, height=400, scrollbars=no");
          break;
        case 'google-plus':
          window.open('https://plus.google.com/share?url='+ encodeURIComponent(window.location.href), 'GooglePlus', "width=680, height=450, scrollbars=no");
          break;
      }
    });
  };

  // Public / Init
  SocialSharing.init = function() {
    bindUIActions();
    injectPinterestScript();
  };

}(window.SocialSharing = window.SocialSharing || {}, jQuery));